// App version - GermanPath starts fresh at 1.0
export const APP_VERSION = "1.0";

// Build timestamp - automatically injected by Vite at build time
// This changes with EVERY deployment, enabling automatic cache invalidation
declare const __BUILD_TIMESTAMP__: string;
export const BUILD_TIMESTAMP = typeof __BUILD_TIMESTAMP__ !== 'undefined' 
  ? __BUILD_TIMESTAMP__ 
  : new Date().toISOString(); // Fallback for dev

// Build date for display reference (derived from timestamp)
export const BUILD_DATE = BUILD_TIMESTAMP.split('T')[0];
